import { useEffect, useState } from 'react';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import { useIsChromiumBrowser } from '@/hooks/useIsChromiumBrowser';
import Button from '@/components/atoms/Button/Button';

const CHORMIUM_BROWSER_LIST = ['Google Chrome', 'Microsoft Edge', 'Opera', 'Brave', 'Chromium', 'Vivaldi', 'Arc'];

const RecommendChromiumBrowserPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isChromiumBrowser } = useIsChromiumBrowser();

  const onClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isChromiumBrowser) {
      setIsOpen(true);
    }
  }, [isChromiumBrowser]);

  const onDownloadChrome = () => {
    window.open('https://www.google.com/chrome/', '_blank');
  };

  return (
    <ContentDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Optimize Your Experience"
      titleSize="large"
      size="small"
      backdropClassName="!bg-black !bg-opacity-80"
      showDivider={false}
    >
      <div className="px-4 pb-4">
        <div className="space-y-3 py-2 text-sm text-[#5c6470]">
          <div>For the best video editing experience, we recommend using a Chromium-based browser such as:</div>
          <ul className="list-disc space-y-1 pl-5">
            {CHORMIUM_BROWSER_LIST.map(browserName => (
              <li key={browserName}>{browserName}</li>
            ))}
          </ul>
          <div>These browsers provide better performance and compatibility with our video editing features.</div>
          <div></div>
        </div>
        <div className="flex justify-between gap-2">
          <Button
            className="!text-sm"
            buttonSize="base"
            variation="outline"
            trackingId="download-chrome"
            onClick={onDownloadChrome}
          >
            Download Chrome
          </Button>
          <Button
            className="!text-sm"
            buttonSize="base"
            variation="filled"
            trackingId="continue-without-downloading"
            onClick={onClose}
          >
            Continue with Current Browser
          </Button>
        </div>
      </div>
    </ContentDialog>
  );
};

export default RecommendChromiumBrowserPopup;
